// Traduction FR -> EN des textes restants : renvoie le texte français tel quel quand l'app est en français
const EN = {
  // Membres bloqués / favoris / matchs / notifications
  "Membres bloqués": "Blocked members",
  "Les membres bloqués ne peuvent plus vous voir, vous contacter ou voir votre profil.": "Blocked members can no longer see you, contact you or view your profile.",
  "Aucun membre bloqué": "No blocked members",
  "Vous n'avez bloqué personne pour le moment": "You haven't blocked anyone yet",
  "Bloqué": "Blocked",
  "Le": "On",
  "Débloquer": "Unblock",
  "Mes Favoris": "My Favorites",
  "Découvrir des profils": "Discover profiles",
  "Ajouté le": "Added on",
  "Messages (": "Messages (",
  "Matchs (": "Matches (",
  "Pas de conversations": "No conversations",
  "Envoyez un message à quelqu'un pour démarrer une conversation !": "Send someone a message to start a conversation!",
  "🎤 Message vocal": "🎤 Voice message",
  "Pas encore de matchs": "No matches yet",
  "Continuez à liker des profils pour avoir des matchs !": "Keep liking profiles to get matches!",
  "Nouveau match ! Dites bonjour 👋": "New match! Say hello 👋",
  "Tout marquer lu": "Mark all as read",
  "Aucune notification": "No notifications",
  "Vos notifications apparaîtront ici": "Your notifications will appear here",
  "Voir": "View",
  // Qui m'a liké
  "Chargement...": "Loading...",
  "Erreur lors du déblocage": "Unlock failed",
  "Erreur de connexion": "Connection error",
  "Tous les profils sont déjà débloqués": "All profiles are already unlocked",
  "Erreur": "Error",
  "C'est un Match ! 🎉": "It's a Match! 🎉",
  "Like envoyé !": "Like sent!",
  "Mes Likes": "My Likes",
  "crédits disponibles": "credits available",
  "Reçus (": "Received (",
  "Envoyés (": "Sent (",
  "profils masqués": "hidden profiles",
  "Débloquez tout d'un coup pour 20 crédits": "Unlock them all at once for 20 credits",
  "Tout voir": "See all",
  "Pas encore de likes": "No likes yet",
  "Complétez votre profil pour recevoir plus de likes !": "Complete your profile to get more likes!",
  "Améliorer mon profil": "Improve my profile",
  "Aucun like envoyé": "No likes sent",
  "Découvrez des profils et likez ceux qui vous plaisent !": "Discover profiles and like the ones you fancy!",
  "Découvrir": "Discover",
  "Profil masqué": "Hidden profile",
  "Débloquer (": "Unlock (",
  "crédits)": "credits)",
  "Liker en retour": "Like back",
  "En attente de réponse...": "Waiting for a reply...",
  // Vérification
  "Main sur le visage": "Hand on face",
  "Signe de paix ✌️": "Peace sign ✌️",
  "Pouce levé 👍": "Thumbs up 👍",
  "Impossible d'accéder à la caméra": "Unable to access the camera",
  "Profil vérifié avec succès !": "Profile verified successfully!",
  "Erreur de vérification": "Verification error",
  "Erreur lors de la vérification": "Verification failed",
  "Vérification du profil": "Profile verification",
  "Vérifiez votre profil": "Verify your profile",
  "Prenez un selfie avec un geste spécifique pour obtenir le badge vérifié": "Take a selfie with a specific gesture to get the verified badge",
  "Choisissez un geste :": "Choose a gesture:",
  "Faites le geste": "Make the gesture",
  "Prendre la photo": "Take the photo",
  "Vérifiez votre photo": "Check your photo",
  "Reprendre": "Retake",
  "Confirmer": "Confirm",
  "Veuillez entrer votre réponse": "Please enter your answer",
  "Réponse incorrecte. Essayez encore !": "Wrong answer. Try again!",
  "Erreur de connexion. Réessayez.": "Connection error. Please try again.",
  "Profil vérifié ! 🎉": "Profile verified! 🎉",
  "Vous avez maintenant le badge vérifié sur votre profil.": "You now have the verified badge on your profile.",
  "Redirection en cours...": "Redirecting...",
  "Obtenez le badge vérifié": "Get the verified badge",
  "Prouvez que vous êtes un humain": "Prove you're a human",
  "Augmentez votre visibilité": "Boost your visibility",
  "Gagnez la confiance des autres membres": "Earn other members' trust",
  "Accédez à plus de fonctionnalités": "Access more features",
  "Résolvez ce calcul": "Solve this sum",
  "Prouvez que vous n'êtes pas un robot": "Prove you're not a robot",
  "Nouveau calcul": "New sum",
  "Votre réponse": "Your answer",
  "Vérification...": "Verifying...",
  "Vérifier mon profil": "Verify my profile",
  "tentative(s) restante(s) avant nouveau calcul": "attempt(s) left before a new sum",
  // Super Like / Match / Modération / Motivation
  "Envoyer un Super Like à": "Send a Super Like to",
  "Coup de cœur instantané": "Instant crush",
  "Le membre sera notifié immédiatement": "The member will be notified instantly",
  "Profil mis en avant": "Featured profile",
  "Votre profil sera prioritaire": "Your profile gets priority",
  "Messages prioritaires": "Priority messages",
  "Vos messages seront vus en premier": "Your messages will be seen first",
  "crédits": "credits",
  "Vos crédits :": "Your credits:",
  "Envoyer le Super Like": "Send the Super Like",
  "Crédits insuffisants": "Not enough credits",
  "Acheter des crédits": "Buy credits",
  "Annuler": "Cancel",
  "C'est un Match !": "It's a Match!",
  "Vous et": "You and",
  "vous êtes mutuellement likés !": "liked each other!",
  "Envoyer un message": "Send a message",
  "Continuer à swiper": "Keep swiping",
  "⚠️ Avertissement Important": "⚠️ Important Warning",
  "signalements reçus": "reports received",
  "Il vous reste": "You have",
  "signalement(s)": "report(s) left",
  "avant le bannissement définitif de votre compte.": "before your account is permanently banned.",
  "📋 Rappel des règles :": "📋 Rules reminder:",
  "• Soyez respectueux envers les autres membres": "• Be respectful to other members",
  "• Pas de contenu inapproprié ou offensant": "• No inappropriate or offensive content",
  "• Pas de harcèlement ni de menaces": "• No harassment or threats",
  "• Utilisez des photos authentiques de vous": "• Use genuine photos of yourself",
  "J'ai compris, je m'engage à respecter les règles": "I understand and agree to follow the rules",
  "🚫 Compte Suspendu": "🚫 Account Suspended",
  "Votre compte a été suspendu définitivement suite à de nombreux signalements de la communauté. Cette décision est irrévocable.": "Your account has been permanently suspended following numerous community reports. This decision is final.",
  "Si vous pensez qu'il s'agit d'une erreur, vous pouvez nous contacter à l'adresse": "If you think this is a mistake, you can contact us at",
  "Fermer": "Close",
  "Message du jour": "Message of the day",
  "Merci pour la motivation !": "Thanks for the motivation!",
  "vous a envoyé un message": "sent you a message",
  "pièces)": "coins)",
  "Utiliser 1 message gratuit (": "Use 1 free message (",
  "Pas assez de pièces ou de messages gratuits": "Not enough coins or free messages",
  // Chat
  "Erreur d'envoi": "Send failed",
  "Erreur d'envoi du message": "Failed to send the message",
  "L'image ne doit pas dépasser 25 Mo": "The image must not exceed 25 MB",
  "Erreur d'envoi de la photo": "Failed to send the photo",
  "Impossible d'accéder au microphone": "Unable to access the microphone",
  "Message vocal envoyé !": "Voice message sent!",
  "Erreur d'envoi du message vocal": "Failed to send the voice message",
  "Envoyez un message pour attirer son attention": "Send a message to catch their attention",
  "Enregistrement...": "Recording...",
  "Terminer": "Finish",
  "Message vocal (": "Voice message (",
  // Découvrir
  "Erreur de chargement des profils": "Failed to load profiles",
  "Ajouté aux favoris ⭐": "Added to favorites ⭐",
  "Super Like envoyé ! 💫": "Super Like sent! 💫",
  "Erreur lors de l'envoi du Super Like": "Failed to send the Super Like",
  "Erreur lors de l'action": "Action failed",
  "Ajouter aux favoris": "Add to favorites",
  "En ligne": "Online",
  "IA": "AI",
  // Profil membre / signalement
  "Profil fake / usurpation d'identité": "Fake profile / identity theft",
  "Harcèlement ou intimidation": "Harassment or bullying",
  "Menaces ou comportement dangereux": "Threats or dangerous behavior",
  "Insultes ou propos haineux": "Insults or hate speech",
  "Contenu inapproprié": "Inappropriate content",
  "Spam ou arnaque": "Spam or scam",
  "Personne mineure": "Underage person",
  "Autre raison": "Other reason",
  "Profil introuvable": "Profile not found",
  "Erreur lors du chargement du profil": "Failed to load the profile",
  "🎉 C'est un Match !": "🎉 It's a Match!",
  "❤️ Like envoyé !": "❤️ Like sent!",
  "⭐ Super Like envoyé !": "⭐ Super Like sent!",
  "Profil passé": "Profile skipped",
  "Veuillez sélectionner une raison": "Please select a reason",
  "Signalement envoyé": "Report sent",
  "Erreur lors du signalement": "Report failed",
  "✅ Membre bloqué avec succès ! Il ne pourra plus vous contacter.": "✅ Member blocked! They can no longer contact you.",
  "Erreur lors du blocage": "Block failed",
  "Centres d'intérêt": "Interests",
  "Recherche": "Looking for",
  "Signaler ce profil": "Report this profile",
  "Aidez-nous à maintenir une communauté sûre. Sélectionnez la raison de votre signalement.": "Help us keep the community safe. Select the reason for your report.",
  "Détails supplémentaires (optionnel)...": "Additional details (optional)...",
  "Bloquer également ce membre": "Also block this member",
  "Il ne pourra plus vous contacter ni voir votre profil": "They will no longer be able to contact you or see your profile",
  "Blocage...": "Blocking...",
  "Bloquer sans signaler": "Block without reporting",
  "Envoi...": "Sending...",
  "Signaler": "Report",
  "Aperçu de mon profil": "My profile preview",
  "👁️ Voici comment les autres membres voient votre profil": "👁️ This is how other members see your profile",
  "À propos": "About",
  "Je recherche": "Looking for",
  "Aperçu des boutons d'action (désactivés)": "Action buttons preview (disabled)",
  // Crédits
  "Boost Profil": "Profile Boost",
  "Voir les Likes": "See Likes",
  "Erreur lors du boost": "Boost failed",
  // Recherche IA / mode bulle
  "Trouve-moi une femme entre 25 et 35 ans qui aime voyager": "Find me a woman between 25 and 35 who loves travelling",
  "Je cherche quelqu'un de sportif près de chez moi": "I'm looking for someone sporty near me",
  "Une personne calme qui aime la lecture et le cinéma": "A calm person who loves reading and movies",
  "Quelqu'un de drôle entre 30 et 45 ans": "Someone funny between 30 and 45",
  "Erreur lors de l'analyse": "Analysis failed",
  "• Genre :": "• Gender:",
  "Femme": "Woman",
  "Homme": "Man",
  "Tous": "All",
  "• Âge :": "• Age:",
  "• Ville :": "• City:",
  "(non trouvée)": "(not found)",
  "• Distance : max": "• Distance: max",
  "• Intérêts :": "• Interests:",
  "• Personnalité :": "• Personality:",
  "Mode Bulle": "Bubble Mode",
  "Voir le profil complet": "View full profile",
  "Faites défiler pour voir plus de profils": "Scroll to see more profiles",
  // Filtres
  "Tous les départements": "All departments",
  "Filtres": "Filters",
  "Tranche d'âge": "Age range",
  "Âge minimum:": "Minimum age:",
  "Âge maximum:": "Maximum age:",
  "Distance maximum": "Maximum distance",
  "Département": "Department",
  "Femmes": "Women",
  "Hommes": "Men",
  "Réinitialiser": "Reset",
  "Appliquer": "Apply",
  "Retour": "Back",
  "Sélectionnez plusieurs options": "Select multiple options",
  "Filtres avancés": "Advanced filters",
  "Minimum:": "Minimum:",
  "Maximum:": "Maximum:",
  "Identité & bases": "Identity & basics",
  "Genre recherché": "Gender sought",
  "Non-binaire": "Non-binary",
  "Hétérosexuel(le)": "Heterosexual",
  "Homosexuel(le)": "Homosexual",
  "Bisexuel(le)": "Bisexual",
  "Pansexuel(le)": "Pansexual",
  "Ville / Zone": "City / Area",
  "Centre-ville": "City centre",
  "Périphérie": "Suburbs",
  "Campagne proche": "Nearby countryside",
  "Toutes": "All",
  "Physique": "Appearance",
  "Taille": "Height",
  "Peu importe": "Doesn't matter",
  "Silhouette": "Body type",
  "Mince": "Slim",
  "Athlétique": "Athletic",
  "Normal(e)": "Average",
  "Ronde": "Curvy",
  "Pulpeuse": "Voluptuous",
  "Corpulent(e)": "Heavyset",
  "Couleur des yeux": "Eye colour",
  "Marron": "Brown",
  "Bleu": "Blue",
  "Vert": "Green",
  "Noisette": "Hazel",
  "Autre": "Other",
  "Couleur des cheveux": "Hair colour",
  "Bruns": "Dark brown",
  "Blonds": "Blond",
  "Châtains": "Light brown",
  "Roux": "Red",
  "Noirs": "Black",
  "Gris / blancs": "Grey / white",
  "Chauve": "Bald",
  "Barbe (hommes)": "Beard (men)",
  "Oui": "Yes",
  "Non": "No",
  "Parfois": "Sometimes",
  "Habitudes & lifestyle": "Habits & lifestyle",
  "Fumeur": "Smoker",
  "Occasionnel": "Occasionally",
  "Régulier": "Regularly",
  "Alcool": "Alcohol",
  "Jamais": "Never",
  "Intensif": "Intensive",
  "Alimentation": "Diet",
  "Classique": "Omnivore",
  "Végétarien(ne)": "Vegetarian",
  "Végan": "Vegan",
  "Flexitarien(ne)": "Flexitarian",
  "Animaux": "Pets",
  "Aucun": "None",
  "Chien": "Dog",
  "Chat": "Cat",
  "Autres": "Others",
  "Aime les animaux": "Loves animals",
  "Enfants & famille": "Children & family",
  "Enfants": "Children",
  "Avec moi": "With me",
  "En garde partagée": "Shared custody",
  "Souhaite des enfants": "Wants children",
  "Peut-être": "Maybe",
  "Situation familiale": "Relationship status",
  "Célibataire": "Single",
  "Divorcé(e)": "Divorced",
  "Séparé(e)": "Separated",
  "Veuf / veuve": "Widowed",
  "Études & travail": "Education & work",
  "Niveau d'études": "Education level",
  "Aucun diplôme": "No degree",
  "CAP / BEP": "Vocational",
  "Bac": "High school",
  "Bac +2": "Associate degree",
  "Bac +3": "Bachelor's degree",
  "Bac +5": "Master's degree",
  "Doctorat": "Doctorate",
  "Étudiant(e)": "Student",
  "Employé(e)": "Employee",
  "Cadre": "Manager",
  "Indépendant(e)": "Freelance",
  "Entrepreneur(e)": "Entrepreneur",
  "Sans emploi": "Unemployed",
  "Retraité(e)": "Retired",
  "Secteur": "Industry",
  "Santé": "Health",
  "Informatique": "IT",
  "Commerce": "Retail",
  "Éducation": "Education",
  "Artisanat": "Crafts",
  "Artistique": "Arts",
  "Intention de rencontre": "Dating intention",
  "Type de relation recherchée": "Relationship sought",
  "Sérieuse": "Serious",
  "Amicale": "Friendship",
  "Occasionnelle": "Casual",
  "Sans pression": "No pressure",
  "Je ne sais pas encore": "Not sure yet",
  "Rythme": "Pace",
  "Lent": "Slow",
  "Rapide": "Fast",
  "Exclusivité": "Exclusivity",
  "À voir": "We'll see",
  "Loisirs & personnalité": "Hobbies & personality",
  "Voyage": "Travel",
  "Musique": "Music",
  "Cinéma / séries": "Movies / series",
  "Lecture": "Reading",
  "Cuisine": "Cooking",
  "Sorties": "Going out",
  "Jeux vidéo": "Video games",
  "Personnalité": "Personality",
  "Calme": "Calm",
  "Dynamique": "Energetic",
  "Drôle": "Funny",
  "Introverti(e)": "Introvert",
  "Extraverti(e)": "Extrovert",
  "Sensible": "Sensitive",
  "Ambitieux(se)": "Ambitious",
  "Humour": "Humour",
  "Très important": "Very important",
  "Important": "Important",
  "Peu important": "Not very important",
  "Ouverture d'esprit": "Open-mindedness",
  "Faible": "Low",
  "Moyenne": "Medium",
  "Élevée": "High",
  "Valeurs & limites": "Values & boundaries",
  "Religion": "Religion",
  "Aucune": "None",
  "Chrétienne": "Christian",
  "Musulmane": "Muslim",
  "Juive": "Jewish",
  "Bouddhiste": "Buddhist",
  "Politique": "Politics",
  "Ne se prononce pas": "Prefer not to say",
  "Gauche": "Left",
  "Centre": "Centre",
  "Droite": "Right",
  "Fidélité": "Fidelity",
  "Essentielle": "Essential",
  "Importante": "Important",
  "Pas prioritaire": "Not a priority",
  "sélectionné(s)": "selected",
  // Légal / connexion
  "N° d'immatriculation :": "Registration no.:",
  "Contact :": "Contact:",
  "Échec de la connexion": "Login failed",
  "Données utilisateur manquantes": "Missing user data",
  "Erreur de connexion. Veuillez réessayer.": "Connection error. Please try again.",
  "Connexion en cours...": "Signing in...",
};

export const isEn = () => (localStorage.getItem("language") || "fr") === "en";

export const tx = (s) => (isEn() && typeof s === "string" ? EN[s] ?? s : s);
